export const duelCatalog = {
  de: {
    title: "Duelle",
    description: "Fordert den Chat zu Duellen um Punkte heraus.",
    challenge: "Duell starten",
    accept: "Duell annehmen",
    challengeCommand: "Herausforderungsbefehl",
    acceptCommand: "Annahmebefehl",
    challengeCommandName: "!duell",
    acceptCommandName: "!ja",
    challengeCommandSyntax: "!duell [@login] [Einsatz]",
    acceptCommandSyntax: "!ja",
    targetArgument: "@login",
    stakeArgument: "Einsatz",
    challengeCommandDescription: "Startet ein offenes oder gezieltes Duell.",
    acceptCommandDescription: "Nimmt ein offenes Duell an.",
    targetHint: "Twitch-Login der herausgeforderten Person.",
    stakeHint: "Punkteinsatz; ohne Angabe gilt der Standardeinsatz.",
    broadcasterModsMayPlayEnabled: "Broadcaster und Moderatoren dürfen mitspielen.",
    broadcasterModsMayPlayDisabled: "Broadcaster und Moderatoren dürfen nicht mitspielen.",
    defaultStake: "Standardeinsatz",
    minStake: "Mindesteinsatz",
    maxStake: "Höchsteinsatz",
    acceptWindowSeconds: "Annahmezeit in Sekunden",
    cooldownSeconds: "Cooldown in Sekunden",
    botAcceptsOpenDuels: "Bot nimmt offene Duelle an",
    broadcasterModsMayPlay: "Broadcaster und Mods spielen mit",
    chatTarget: "Chat-Ausgabe",
    texts: "Chat-Texte",
    challengeOpen: "⚔️ {challenger} fordert den Chat zu einem Duell um {stake} Punkte heraus! Mit {acceptCommand} annehmen.",
    challengeTargeted: "⚔️ {challenger} fordert @{target} zu einem Duell um {stake} Punkte heraus! Mit {acceptCommand} annehmen.",
    result: "{fight} {winner} gewinnt {net} Punkte; {loser} verliert {loss} Punkte!",
    botResult: "🧹 Niemand wollte – der Hausmeister krempelt die Ärmel hoch! {fight} {winner} gewinnt {net} Punkte; {loser} verliert {loss} Punkte!",
    fightVariants: [
      "Die Klingen kreuzen sich im Sternenlicht.",
      "Ein schneller Ausweichschritt entscheidet den Kampf.",
      "Der letzte Treffer hallt durch die Arena.",
    ],
    botFightVariants: [
      "Der Bot startet ein pixelgenaues Manöver.",
      "Ein Funkenregen erfüllt die digitale Arena.",
      "Der Bot setzt zum finalen Gegenangriff an.",
    ],
    errors: {
      notEnoughPoints: "Du hast nicht genug Punkte für diesen Einsatz.",
      invalidStake: "Bitte gib einen positiven ganzzahligen Einsatz an.",
      unknownUser: "Diese Person wurde auf Twitch nicht gefunden.",
      targetBusy: "Diese Person hat bereits ein offenes Duell.",
      alreadyChallenging: "Du hast bereits ein offenes Duell.",
      cooldown: "Warte noch {{seconds}} Sekunden, bevor du erneut herausforderst.",
      noOpenChallenge: "Es gibt gerade kein offenes Duell für dich.",
      cannotAcceptOwn: "Du kannst dein eigenes Duell nicht annehmen.",
      stakeBounds: "Der Einsatz muss zwischen {{min}} und {{max}} Punkten liegen.",
      tooManyOpen: "Es sind gerade zu viele Duelle offen.",
    },
  },
  en: {
    title: "Duels",
    description: "Challenge chat to point duels.",
    challenge: "Start a duel",
    accept: "Accept a duel",
    challengeCommand: "Challenge command",
    acceptCommand: "Accept command",
    challengeCommandName: "!duel",
    acceptCommandName: "!yes",
    challengeCommandSyntax: "!duel [@login] [stake]",
    acceptCommandSyntax: "!yes",
    targetArgument: "@login",
    stakeArgument: "stake",
    challengeCommandDescription: "Starts an open or targeted duel.",
    acceptCommandDescription: "Accepts an open duel.",
    targetHint: "Twitch login of the challenged player.",
    stakeHint: "Point stake; the default stake is used when omitted.",
    broadcasterModsMayPlayEnabled: "Broadcasters and moderators may play.",
    broadcasterModsMayPlayDisabled: "Broadcasters and moderators may not play.",
    defaultStake: "Default stake",
    minStake: "Minimum stake",
    maxStake: "Maximum stake",
    acceptWindowSeconds: "Accept window in seconds",
    cooldownSeconds: "Cooldown in seconds",
    botAcceptsOpenDuels: "Bot accepts open duels",
    broadcasterModsMayPlay: "Broadcasters and moderators may play",
    chatTarget: "Chat output",
    texts: "Chat texts",
    challengeOpen: "⚔️ {challenger} challenges chat to a {stake} point duel! Type {acceptCommand} to accept.",
    challengeTargeted: "⚔️ {challenger} challenges @{target} to a {stake} point duel! Type {acceptCommand} to accept.",
    result: "{fight} {winner} wins {net} points; {loser} loses {loss} points!",
    botResult: "🧹 Nobody stepped up, so the janitor rolls up their sleeves! {fight} {winner} wins {net} points; {loser} loses {loss} points!",
    fightVariants: [
      "Blades cross beneath the starlight.",
      "A quick dodge decides the fight.",
      "The final strike echoes through the arena.",
    ],
    botFightVariants: [
      "The bot runs a pixel-perfect maneuver.",
      "Sparks fill the digital arena.",
      "The bot launches its final counterattack.",
    ],
    errors: {
      notEnoughPoints: "You do not have enough points for that stake.",
      invalidStake: "Enter a positive whole number for the stake.",
      unknownUser: "That person could not be found on Twitch.",
      targetBusy: "That person already has an open duel.",
      alreadyChallenging: "You already have an open duel.",
      cooldown: "Wait {{seconds}} seconds before challenging again.",
      noOpenChallenge: "There is no open duel for you right now.",
      cannotAcceptOwn: "You cannot accept your own duel.",
      stakeBounds: "The stake must be between {{min}} and {{max}} points.",
      tooManyOpen: "There are too many open duels right now.",
    },
  },
} as const;

export const duelPanelCopy = {
  de: {
    save: "Speichern",
    saved: "Gespeichert",
    saveError: "Einstellungen konnten nicht gespeichert werden.",
    invalid: "Bitte prüfe deine Eingaben.",
    roundRunning: "Offene Duelle",
    cancel: "Runde abbrechen",
    cancelConfirm: "Einsätze werden erstattet",
    cancelError: "Das Duell konnte nicht abgebrochen werden.",
    cancelSuccess: "Einsatz erstattet",
    open: "Offen",
    stake: "Einsatz",
    closesAt: "Endet",
    more: "+{{count}} weitere",
    commandsDiffer: "Die Befehle müssen verschieden sein.",
    bounds: "Mindesteinsatz ≤ Standardeinsatz ≤ Höchsteinsatz, höchstens 100.000.",
    textChallengeOpen: "Offene Duellansage",
    textChallengeTargeted: "Gezielte Duellansage",
    textResult: "Ergebnistext",
    textBotResult: "Ergebnistext gegen den Bot",
    messageEnabled: "Nachricht senden",
    messageMissing: "Text fehlt",
    messageOn: "An",
    messageOff: "Aus",
    errorNotEnoughPoints: "Nicht genug Punkte",
    errorInvalidStake: "Ungültiger Einsatz",
    errorUnknownUser: "Unbekannte Person",
    errorTargetBusy: "Ziel bereits herausgefordert",
    errorAlreadyChallenging: "Duell bereits offen",
    errorCooldown: "Cooldown",
    errorNoOpenChallenge: "Kein offenes Duell",
    errorCannotAcceptOwn: "Eigenes Duell nicht annehmbar",
    errorStakeBounds: "Einsatz außerhalb des Bereichs",
    errorTooManyOpen: "Zu viele offene Duelle",
    fight: "Kampftext {{index}}",
    botFight: "Kampftext gegen den Bot {{index}}",
    botEnabled: "An",
    botDisabled: "Aus",
    layoutTestId: "duel-settings-page",
  },
  en: {
    save: "Save",
    saved: "Saved",
    saveError: "Settings could not be saved.",
    invalid: "Check the values and try again.",
    roundRunning: "Open duels",
    cancel: "Cancel round",
    cancelConfirm: "Stakes will be refunded",
    cancelError: "The duel could not be cancelled.",
    cancelSuccess: "Stake refunded",
    open: "Open",
    stake: "Stake",
    closesAt: "Closes",
    more: "+{{count}} more",
    commandsDiffer: "The commands must be different.",
    bounds: "Minimum stake ≤ default stake ≤ maximum stake, up to 100,000.",
    textChallengeOpen: "Open duel announcement",
    textChallengeTargeted: "Targeted duel announcement",
    textResult: "Result text",
    textBotResult: "Result text against the bot",
    messageEnabled: "Send message",
    messageMissing: "Text missing",
    messageOn: "On",
    messageOff: "Off",
    errorNotEnoughPoints: "Not enough points",
    errorInvalidStake: "Invalid stake",
    errorUnknownUser: "Unknown user",
    errorTargetBusy: "Target already challenged",
    errorAlreadyChallenging: "Duel already open",
    errorCooldown: "Cooldown",
    errorNoOpenChallenge: "No open duel",
    errorCannotAcceptOwn: "Cannot accept own duel",
    errorStakeBounds: "Stake outside range",
    errorTooManyOpen: "Too many open duels",
    fight: "Fight text {{index}}",
    botFight: "Fight text against the bot {{index}}",
    botEnabled: "On",
    botDisabled: "Off",
    layoutTestId: "duel-settings-page",
  },
} as const;
